<div class="flex flex-col gap-3">
  <p class="text-sm text-slate-500">
    Configura los horarios de atención para <strong>{{ recurso().nombre }}</strong>
  </p>
  @for (h of horariosEdit(); track h.dia_semana) {
    <div class="flex items-center gap-3 p-2.5 rounded-lg border border-slate-200">
      <label class="flex items-center gap-2 min-w-28">
        <input type="checkbox" [(ngModel)]="h.activo" class="w-4 h-4" />
        <span class="text-sm font-medium">{{ dayLabels[h.dia_semana] }}</span>
      </label>
      @if (h.activo) {
        <input type="time" [(ngModel)]="h.hora_inicio" class="rounded-lg border border-slate-200 p-1.5 text-sm w-28 focus:outline-none focus:ring-2 focus:ring-accent-500/20" />
        <span class="text-sm">a</span>
        <input type="time" [(ngModel)]="h.hora_fin" class="rounded-lg border border-slate-200 p-1.5 text-sm w-28 focus:outline-none focus:ring-2 focus:ring-accent-500/20" />
      } @else {
        <span class="text-sm text-slate-400">Cerrado</span>
      }
    </div>
  }
  <div class="flex justify-end gap-2 pt-2">
    <app-button label="Cancelar" variant="secondary" (onClick)="onCerrar()" />
    <app-button label="Guardar horarios" (onClick)="guardar()" />
  </div>
</div>
